// Initialize Miete List from localStorage or create a new one
var mieteList = JSON.parse(localStorage.getItem("mieteList")) || [];
var variantOptionList = JSON.parse(localStorage.getItem("variantList")) || [];

if (mieteList.length == 1 && mieteList[0] == null) {
  mieteList = [];
}

// Event Listener for Add to Miete Button
document.addEventListener("DOMContentLoaded", function () {
  document.querySelector(".miete-success-msg-container").style.display = "none";
  var mieteButtons = document.querySelectorAll(".add-to-miete-button");

  mieteButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var provideOptionNodes = document.querySelectorAll(
        ".m-product-option--node"
      );
      var activeOption = "";
      provideOptionNodes.forEach(function (optionNode) {
        if (optionNode.children[0].checked) {
          activeOption = optionNode.children[1].innerText;
        }
      });
      var productHandle = this.getAttribute("data-product-handle");
      addToMieteList(productHandle, activeOption);
    });
  });
});

function updateFloatingButton() {
  var mieteList = JSON.parse(localStorage.getItem("mieteList")) || [];
  var floatingButton = document.getElementById("floating-miete-button");
  var floatingButtonMobile = document.getElementById(
    "floating-miete-button-mobile"
  );
  var mieteCount = document.getElementById("miete-count");
  var mieteCountMobile = document.getElementById("miete-count-mobile");

  if (mieteList.length > 0 && mieteList[0] !== null) {
    floatingButton.style.display = "block";
    floatingButtonMobile.style.display = "block";
    mieteCount.textContent = mieteList.length;
    mieteCountMobile.textContent = mieteList.length;
    floatingButton.classList.remove("miete-highlight");
    void floatingButton.offsetWidth;
    void floatingButtonMobile.offsetWidth;
    floatingButton.classList.add("miete-highlight");
  } else {
    floatingButton.style.display = "none";
    floatingButtonMobile.style.display = "none";
    mieteCount.textContent = "0";
    mieteCountMobile.textContent = "0";
    floatingButton.classList.remove("miete-highlight");
  }
}

// Call the function when the DOM content is loaded
document.addEventListener("DOMContentLoaded", function () {
  updateFloatingButton();
});

// Update the button when items are added or removed
// Modify existing addToMieteList and removeFromMieteList functions

// Existing function to add product to Miete List
function addToMieteList(productHandle, activateOption) {
  if (!mieteList.includes(productHandle)) {
    mieteList.push(productHandle);
    var newVariantOption = {
      [productHandle]: activateOption,
    };
    var isNewOption = true;
    variantOptionList.forEach(function (option) {
      if (option[productHandle]) {
        option[productHandle] = activateOption;
        isNewOption = false;
      }
    });
    if (isNewOption) variantOptionList.push(newVariantOption);
    localStorage.setItem("mieteList", JSON.stringify(mieteList));
    localStorage.setItem("variantList", JSON.stringify(variantOptionList));
    updateFloatingButton(); // Add this line
    document.querySelector(".miete-success-msg-container").style.display =
      "block";
  } else {
    alert("Das Produkt ist bereits auf deiner Mietanfrage.");
  }
}

// Existing function to remove product from Miete List
// If you have this function in your miete.js, ensure it updates the button
function removeFromMieteList(productHandle) {
  mieteList = mieteList.filter(function (handle) {
    return handle !== productHandle;
  });
  localStorage.setItem("mieteList", JSON.stringify(mieteList));
  updateFloatingButton(); // Add this line
}
